// Theme: neon-flare
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'neon-flare',
  name: 'NEON FLARE',
  tagline: 'NEON FLARE',
  description: 'Laranja neon intenso de sinalizacao urbana noturna.',
  category: 'neon-cyber',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#240D04', '#3A1808', '#FF4D00', '#FFE5D6'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-neon-flare'
  },
  colorVars: {
    '--accent': '#FF4D00',
    '--accent-foreground': '#240D04',
    '--background': '#240D04',
    '--border': '#8A3A10',
    '--card': '#3A1808',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FFE5D6',
    '--card-glow': 'color-mix(in srgb, var(--primary) 8%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#240D04',
    '--foreground': '#FFE5D6',
    '--hold-fill': '#FF4D00',
    '--input': '#8A3A10',
    '--modal-bg': '#240D04',
    '--modal-border': '#8A3A10',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#8A3A10',
    '--muted-foreground': '#FFE5D6',
    '--nav-active': '#FF4D00',
    '--nav-bg': '#3A1808',
    '--popover': '#3A1808',
    '--popover-foreground': '#FFE5D6',
    '--primary': '#FF4D00',
    '--primary-foreground': '#240D04',
    '--ring': '#FF4D00',
    '--secondary': '#8A3A10',
    '--secondary-foreground': '#FFE5D6',
    '--streak': '#FF4D00',
    '--success': '#22c55e',
    '--success-foreground': '#240D04',
    '--xp': '#FF4D00',
    '--xp-bg': '#3A1808'
  },
  resolvedVars: {
    '--accent': '#FF4D00',
    '--accent-foreground': '#240D04',
    '--accent-foreground-hsl': '17 80% 8%',
    '--accent-foreground-oklch': 'from #240D04 l c h',
    '--accent-hsl': '18 100% 50%',
    '--accent-oklch': 'from #FF4D00 l c h',
    '--background': '#240D04',
    '--background-hsl': '17 80% 8%',
    '--background-oklch': 'from #240D04 l c h',
    '--border': '#8A3A10',
    '--border-hsl': '21 79% 30%',
    '--border-oklch': 'from #8A3A10 l c h',
    '--border-w': '1px',
    '--card': '#3A1808',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FFE5D6',
    '--card-foreground-hsl': '22 100% 92%',
    '--card-foreground-oklch': 'from #FFE5D6 l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 8%, transparent)',
    '--card-hsl': '19 76% 13%',
    '--card-oklch': 'from #3A1808 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#240D04',
    '--destructive-foreground-hsl': '17 80% 8%',
    '--destructive-foreground-oklch': 'from #240D04 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FFE5D6',
    '--foreground-hsl': '22 100% 92%',
    '--foreground-oklch': 'from #FFE5D6 l c h',
    '--hold-fill': '#FF4D00',
    '--hold-fill-hsl': '18 100% 50%',
    '--hold-fill-oklch': 'from #FF4D00 l c h',
    '--input': '#8A3A10',
    '--input-hsl': '21 79% 30%',
    '--input-oklch': 'from #8A3A10 l c h',
    '--modal-bg': '#240D04',
    '--modal-bg-hsl': '17 80% 8%',
    '--modal-bg-oklch': 'from #240D04 l c h',
    '--modal-border': '#8A3A10',
    '--modal-border-hsl': '21 79% 30%',
    '--modal-border-oklch': 'from #8A3A10 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#8A3A10',
    '--muted-foreground': '#FFE5D6',
    '--muted-foreground-hsl': '22 100% 92%',
    '--muted-foreground-oklch': 'from #FFE5D6 l c h',
    '--muted-hsl': '21 79% 30%',
    '--muted-oklch': 'from #8A3A10 l c h',
    '--nav-active': '#FF4D00',
    '--nav-active-hsl': '18 100% 50%',
    '--nav-active-oklch': 'from #FF4D00 l c h',
    '--nav-bg': '#3A1808',
    '--nav-bg-hsl': '19 76% 13%',
    '--nav-bg-oklch': 'from #3A1808 l c h',
    '--popover': '#3A1808',
    '--popover-foreground': '#FFE5D6',
    '--popover-foreground-hsl': '22 100% 92%',
    '--popover-foreground-oklch': 'from #FFE5D6 l c h',
    '--popover-hsl': '19 76% 13%',
    '--popover-oklch': 'from #3A1808 l c h',
    '--primary': '#FF4D00',
    '--primary-foreground': '#240D04',
    '--primary-foreground-hsl': '17 80% 8%',
    '--primary-foreground-oklch': 'from #240D04 l c h',
    '--primary-hsl': '18 100% 50%',
    '--primary-oklch': 'from #FF4D00 l c h',
    '--radius': '10px',
    '--ring': '#FF4D00',
    '--ring-hsl': '18 100% 50%',
    '--ring-oklch': 'from #FF4D00 l c h',
    '--secondary': '#8A3A10',
    '--secondary-foreground': '#FFE5D6',
    '--secondary-foreground-hsl': '22 100% 92%',
    '--secondary-foreground-oklch': 'from #FFE5D6 l c h',
    '--secondary-hsl': '21 79% 30%',
    '--secondary-oklch': 'from #8A3A10 l c h',
    '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#FF4D00',
    '--streak-hsl': '18 100% 50%',
    '--streak-oklch': 'from #FF4D00 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#240D04',
    '--success-foreground-hsl': '17 80% 8%',
    '--success-foreground-oklch': 'from #240D04 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(18 100% 50% / 0.15)',
    '--xp': '#FF4D00',
    '--xp-bg': '#3A1808',
    '--xp-bg-hsl': '19 76% 13%',
    '--xp-bg-oklch': 'from #3A1808 l c h',
    '--xp-hsl': '18 100% 50%',
    '--xp-oklch': 'from #FF4D00 l c h'
  }
}
